import { Form } from 'antd';
import { FC, useState } from 'react';
import {
  AddUserFormInterface,
  EditUserFormInterface,
  UserDetails,
} from '../../../constants/types';
import UserForm from './UserForm';

interface Props {
  userDetails: UserDetails;
  onSubmit: Function;
}

const EditUserForm: FC<Props> = ({ onSubmit, userDetails }) => {
  const [form] = Form.useForm();
  const [isFormSubmit, setIsFormSubmit] = useState(false);

  const onFinish = async (
    values: AddUserFormInterface | EditUserFormInterface,
  ) => {
    const formValue = JSON.parse(
      JSON.stringify(values),
    ) as EditUserFormInterface;
    const updatedUserDetail: any = {
      firstName: formValue.firstName.trim(),
      lastName: formValue.lastName.trim(),
      groups: formValue.groups,
      sendResetLink: formValue.sendResetLink,
      enabled: true,
      configure_totp: formValue.configure_totp,
    };

    if (formValue.account_end_date) {
      updatedUserDetail.account_end_date = formValue.account_end_date;
    }

    setIsFormSubmit(true);
    await onSubmit(updatedUserDetail);
    setIsFormSubmit(false);
  };

  return (
    <UserForm
      type="edit"
      form={form}
      formSubmit={onFinish}
      isFormSubmit={isFormSubmit}
      userDetails={userDetails}
    />
  );
};

export default EditUserForm;
